import React from 'react';
import {TaskSingleVoyageTransformForTable, TaskWayPointSingleVoyage} from "@containers/singleVoyage/tasks/table/types";
import {OnDeleteTaskSingleVoyage, OnSaveTaskSingleVoyage} from "@containers/singleVoyage/tasks/table/types/events";
import MutateTaskSingleVoyageModal from "@containers/singleVoyage/tasks/mutateTask/MutateTaskModalSingleVoyage";
import {useConfirm} from "@hooks/alert/useConfirm";
import {useTranslation} from 'react-i18next';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';

const sx = {
	iconDelete: {
		width: '20px',
		height: '20px',
		transition: 'all .3s',
		'&:hover': {
			cursor: 'pointer'
		}
	},
}
const ActionBarTaskTableSingleVoyage = ({
											initial,
											onSave,
											voyageId,
											waypoints,
											onDelete,
											accountId,
										}: {
	initial: TaskSingleVoyageTransformForTable,
	onSave?: OnSaveTaskSingleVoyage,
	voyageId: number
	accountId: number | string
	waypoints: TaskWayPointSingleVoyage[]
	onDelete?: OnDeleteTaskSingleVoyage,
	
}) => {
	
	const {setConfirm} = useConfirm()
	const {t} = useTranslation()
	
	
	const onDeleteTask = async () => {
		if (!onDelete) {
			return
		}
		setConfirm({
			message: t('confirmDeleteMessage'),
			callback: async () => {
				await onDelete({
					task: initial,
					voyageId,
				})
			}
		})
	}
	
	
	return (
		<Stack
			gap={1}
			direction={'row'}
			alignItems={'center'}
		>
			{onSave && <MutateTaskSingleVoyageModal
                initial={initial}
                voyageId={voyageId}
                onSave={onSave}
                waypoints={waypoints}
                accountId={accountId}

            />}
			{onDelete && <DeleteIcon
                onClick={onDeleteTask}
                sx={sx.iconDelete}
            />}
		</Stack>
	);
};

export default ActionBarTaskTableSingleVoyage;
